import { captionStyle } from "@/components/infra/infra-styles";
import type { InfraStatusTone } from "@/lib/infra-placement";

/** 種類ごとの件数。押すとその種類で絞り込む (複数選べる)。種類は属性なので色を付けない。 */
export function KindFilterChip({
	label,
	value,
	selected,
	onClick,
	testId,
}: {
	label: string;
	value: number;
	selected: boolean;
	onClick: () => void;
	testId: string;
}) {
	return (
		<button
			type="button"
			data-testid={testId}
			onClick={onClick}
			style={{
				display: "flex",
				alignItems: "baseline",
				gap: 6,
				padding: "6px 12px",
				border: "none",
				borderRadius: "var(--radius-2)",
				background: "var(--surface-2)",
				boxShadow: selected ? "var(--shadow-ring-strong)" : "none",
				fontFamily: "inherit",
				cursor: "pointer",
			}}
		>
			<span style={captionStyle({ color: selected ? "var(--fg-1)" : "var(--fg-3)" })}>{label}</span>
			<span
				style={{
					fontSize: "var(--text-ui)",
					fontWeight: 600,
					color: selected ? "var(--fg-0)" : "var(--fg-1)",
				}}
			>
				{value}
			</span>
		</button>
	);
}

export function SummaryChip({
	label,
	value,
	tone,
}: {
	label: string;
	value: number;
	tone?: InfraStatusTone;
}) {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "baseline",
				gap: 6,
				padding: "6px 12px",
				borderRadius: "var(--radius-2)",
				background: tone ? `var(--${tone}-subtle)` : "var(--surface-2)",
			}}
		>
			<span style={captionStyle({ color: tone ? `var(--${tone})` : "var(--fg-3)" })}>{label}</span>
			<span
				style={{
					fontSize: "var(--text-ui)",
					fontWeight: 600,
					color: tone ? `var(--${tone})` : "var(--fg-1)",
				}}
			>
				{value}
			</span>
		</div>
	);
}

/** 状態や種類を示す丸札。tone を省くと色を付けない (種類のような属性に使う)。 */
export function Pill({ label, tone }: { label: string; tone?: InfraStatusTone }) {
	return (
		<span
			style={{
				display: "inline-block",
				padding: "2px 8px",
				borderRadius: "var(--radius-full)",
				background: tone ? `var(--${tone}-subtle)` : "var(--surface-2)",
				color: tone ? `var(--${tone})` : "var(--fg-2)",
				fontSize: "var(--text-caption)",
				fontWeight: 500,
				whiteSpace: "nowrap",
			}}
		>
			{label}
		</span>
	);
}
